import { render, staticRenderFns } from "./TestSidebar.vue?vue&type=template&id=5ead96bd&"
import script from "./TestSidebar.vue?vue&type=script&lang=js&"
export * from "./TestSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports